import { createReducer } from 'reduxsauce'
import Types from './actionTypes'
 
export const INITIAL_STATE = { isloading: false, error: false, object: null, boat_types: null, jetty_types: null, drive_types: null, selectedObjectType: null, selectedObjectName: null }

export const fetchObject = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, error: false };
}
 
export const fetchObjectSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: false, object: action.responseData };
}
 
export const fetchObjectFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: true, error_message: action.error };
}

export const fetchBoatTypes = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, error: false };
}
 
export const fetchBoatTypesSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: false, boat_types: action.responseData };
}
 
export const fetchBoatTypesFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: true, error_message: action.error };
}

export const fetchJettyTypes = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, error: false };
}
 
export const fetchJettyTypesSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: false, jetty_types: action.responseData };
}
 
export const fetchJettyTypesFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: true, error_message: action.error };
}

export const fetchDriveTypes = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, error: false };
}
 
export const fetchDriveTypesSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: false, drive_types: action.responseData };
}
 
export const fetchDriveTypesFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: true, error_message: action.error };
}

export const saveObject = (state = INITIAL_STATE, action) => {
  return { ...state, object: action.payload };
}

export const selectObject = (state = INITIAL_STATE, action) => {
  return { ...state, selectedObjectType: action.objectType, selectedObjectName: action.objectName };
}

export const updateObject = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, error: false };
}
 
export const updateObjectSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: false, object: action.responseData };
}
 
export const updateObjectFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: true, error_message: action.error };
}

export const HANDLERS = {
  [Types.FETCH_OBJECT]: fetchObject,
  [Types.FETCH_OBJECT_SUCCESS]: fetchObjectSuccess,
  [Types.FETCH_OBJECT_FAILURE]: fetchObjectFailure,
  [Types.FETCH_BOAT_TYPES]: fetchBoatTypes,
  [Types.FETCH_BOAT_TYPES_SUCCESS]: fetchBoatTypesSuccess,
  [Types.FETCH_BOAT_TYPES_FAILURE]: fetchBoatTypesFailure,
  [Types.FETCH_JETTY_TYPES]: fetchJettyTypes,
  [Types.FETCH_JETTY_TYPES_SUCCESS]: fetchJettyTypesSuccess,
  [Types.FETCH_JETTY_TYPES_FAILURE]: fetchJettyTypesFailure,
  [Types.FETCH_DRIVE_TYPES]: fetchDriveTypes,
  [Types.FETCH_DRIVE_TYPES_SUCCESS]: fetchDriveTypesSuccess,
  [Types.FETCH_DRIVE_TYPES_FAILURE]: fetchDriveTypesFailure,
  [Types.SAVE_OBJECT]: saveObject,
  [Types.SELECT_OBJECT]: selectObject,
  [Types.UPDATE_OBJECT]: updateObject,
  [Types.UPDATE_OBJECT_SUCCESS]: updateObjectSuccess,
  [Types.UPDATE_OBJECT_FAILURE]: updateObjectFailure
}
 
export default createReducer(INITIAL_STATE, HANDLERS);
